import { CONFIG } from "../config"

export class CallToAction {
  private config: DOMStringMap

  constructor({ config }: { config: DOMStringMap }) {
    this.config = config
  }

  public render(): HTMLDivElement {
    const cta = document.createElement("div")
    cta.role = "button"
    cta.className = [CONFIG.CTA_CLASS, this.config.tfgCtaClass || ""].join(" ")
    cta.textContent = this.config.tfgCtaText || "Origine et impact"
    return cta
  }
}
